import {
    SUPPLIER_COM_SUPPLIER,
    SUPPLIER_COM_SUPPLIER_SUCCESS,
    SUPPLIER_COM_SUPPLIER_ERROR,
    SUPPLIER_COM_EMAIL,
    SUPPLIER_COM_EMAIL_SUCCESS,
    SUPPLIER_COM_EMAIL_ERROR,
    SUPPLIER_COM_PO,
    SUPPLIER_COM_PO_SUCCESS,
    SUPPLIER_COM_PO_ERROR,
    SUPPLIER_COM_CATEGORY,
    SUPPLIER_COM_CATEGORY_SUCCESS,
    SUPPLIER_COM_CATEGORY_ERROR,
    SUPPLIER_COMMUNICATION_LIST,
    SUPPLIER_COMMUNICATION_LIST_SUCCESS,
    SUPPLIER_COMMUNICATION_LIST_ERROR,
    SUPPLIER_COMMUNICATION_SEARCH_CHANGE,
    SUPPLIER_COMMUNICATION_PAGE_SET,
    SUPPLIER_COMMUNICATION_ADD_MODAL_SET,
    SUPPLIER_COMMUNICATION_ADD_SET_DATA,
    SUPPLIER_COMMUNICATION_ADD_CHANGE_SET,
    SUPPLIER_COMMUNICATION_ADD,
    SUPPLIER_COMMUNICATION_ADD_SUCCESS,
    SUPPLIER_COMMUNICATION_ADD_ERROR,
    SUPPLIER_COMMUNICATION_EDIT_MODAL_SET,
    SUPPLIER_COMMUNICATION_EDIT_SET_DATA,
    SUPPLIER_COMMUNICATION_EDIT_CHANGE_SET,
    SUPPLIER_COMMUNICATION_EDIT,
    SUPPLIER_COMMUNICATION_EDIT_SUCCESS,
    SUPPLIER_COMMUNICATION_EDIT_ERROR,
    SUPPLIER_COMMUNICATION_UPLOAD_SET,
    SUPPLIER_COMMUNICATION_UPLOAD_SET_SUCCESS,
    SUPPLIER_COMMUNICATION_UPLOAD_SET_ERROR,
    SUPPLIER_COMMUNICATION_UPLOAD_RESET,
    SUPPLIER_COMMUNICATION_SEE_MODAL_SET,
    SUPPLIER_COMMUNICATION_SEE_SET_DATA,
} from "../../actions";

const INIT_STATE = {
    loading: false,
    list: {
        page: {
            current: 1,
            rows: 10
        }
    },
    supplier: {
        loading: false,
        data: []
    },
    supplieremail: {
        loading: false,
        data: []
    },
    po: {
        loading: false,
        data: []
    },
    category: {
        loading: false,
        data: []
    },
    detail: {
        data: []
    },
    add: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    detailsee: {
        data: []
    },
    see: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    detailedit: {
        data: []
    },
    edit: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    file: [],
    error: false,
    search: {
        modal: false,
        init: true,
        data: {
            supplier: '',
            status: '',
            category: '',
            status:''
        },
        value: {
            supplier: '',
            status: '',
            category: '',
            status: ''
        }
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SUPPLIER_COM_SUPPLIER:
            return {
                ...state,
                loading: true,
                supplier: {
                    ...state.supplier
                }
            }
        case SUPPLIER_COM_SUPPLIER_SUCCESS:
            return {
                ...state,
                loading: false,
                supplier: {
                    ...state.supplier,
                    ...action.payload
                }
            }
        case SUPPLIER_COM_SUPPLIER_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case SUPPLIER_COM_EMAIL:
            return {
                ...state,
                loading: true,
                supplieremail: {
                    ...state.supplieremail
                }
            }
        case SUPPLIER_COM_EMAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                supplieremail: {
                    ...state.supplieremail,
                    ...action.payload
                }
            }
        case SUPPLIER_COM_EMAIL_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case SUPPLIER_COM_PO:
            return {
                ...state,
                loading: true,
                po: {
                    ...state.po
                }
            }
        case SUPPLIER_COM_PO_SUCCESS:
            return {
                ...state,
                loading: false,
                po: {
                    ...state.po,
                    ...action.payload
                }
            }
        case SUPPLIER_COM_PO_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case SUPPLIER_COM_CATEGORY:
            return {
                ...state,
                loading: true,
                category: {
                    ...state.category
                }
            }
        case SUPPLIER_COM_CATEGORY_SUCCESS:
            return {
                ...state,
                loading: false,
                category: {
                    ...state.category,
                    ...action.payload
                }
            }
        case SUPPLIER_COM_CATEGORY_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        case SUPPLIER_COMMUNICATION_LIST:
            return {
                ...state,
                loading: true,
                list: {
                    ...state.list
                }
            }
        case SUPPLIER_COMMUNICATION_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case SUPPLIER_COMMUNICATION_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case SUPPLIER_COMMUNICATION_PAGE_SET:
            return {
                ...state,
                list: {
                    ...state.list,
                    page: {
                        ...state.list.page,
                        ...action.payload,
                    }
                }
            }
        case SUPPLIER_COMMUNICATION_SEARCH_CHANGE:
            return {
                ...state,
                search: {
                    ...state.search,
                    data: action.payload,
                }
            }
        case SUPPLIER_COMMUNICATION_ADD_MODAL_SET:
            return {
                ...state,
                add: {
                    ...state.add,
                    modal: action.payload
                }
            }
        case SUPPLIER_COMMUNICATION_ADD_SET_DATA:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    ...action.payload
                }
            }
        case SUPPLIER_COMMUNICATION_ADD_CHANGE_SET:
            return {
                ...state,
                add: {
                    ...state.add,
                    data: {
                        ...state.add.data,
                        ...action.payload
                    }
                }
            }
        case SUPPLIER_COMMUNICATION_ADD:
            return {
                ...state,
                add: {
                    ...state.add,
                    loading: false
                }
            }
        case SUPPLIER_COMMUNICATION_ADD_SUCCESS:
            return {
                ...state,
                add: {
                    ...state.add,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case SUPPLIER_COMMUNICATION_ADD_ERROR:
            return {
                ...state,
                add: {
                    ...state.add,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case SUPPLIER_COMMUNICATION_EDIT_MODAL_SET:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    modal: action.payload
                }
            }
        case SUPPLIER_COMMUNICATION_EDIT_SET_DATA:
            return {
                ...state,
                detailedit: {
                    ...state.detailedit,
                    ...action.payload
                }
            }
        case SUPPLIER_COMMUNICATION_EDIT_CHANGE_SET:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    data: {
                        ...state.edit.data,
                        ...action.payload
                    }
                }
            }
        case SUPPLIER_COMMUNICATION_EDIT:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    loading: false
                }
            }
        case SUPPLIER_COMMUNICATION_EDIT_SUCCESS:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case SUPPLIER_COMMUNICATION_EDIT_ERROR:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case SUPPLIER_COMMUNICATION_UPLOAD_SET:
            return { ...state };

        case SUPPLIER_COMMUNICATION_UPLOAD_SET_SUCCESS:
            return {
                ...state,
                file: { ...state.file, ...action.payload }
            };

        case SUPPLIER_COMMUNICATION_UPLOAD_SET_ERROR:
            return {
                ...state,
                file: { ...state.file, ...action.payload }
            };

        case SUPPLIER_COMMUNICATION_UPLOAD_RESET:
            return {
                ...state,
                file: []
            };

        case SUPPLIER_COMMUNICATION_SEE_MODAL_SET:
            return {
                ...state,
                see: {
                    ...state.see,
                    modal: action.payload
                }
            }
        case SUPPLIER_COMMUNICATION_SEE_SET_DATA:
            return {
                ...state,
                detailsee: {
                    ...state.detailsee,
                    ...action.payload
                }
            }

        default:
            return { ...state };
    }
};